<template>
  <div class="gd606-status-bar" type="flex">
    <div class="gd606-status-top">
      <!-- <el-col tag="span" :span="4">
        {{$t('设备联网方式')}}：
        <span :class="0 | alarmClass">{{ networkMode | networkHandler }}</span>
      </el-col> -->
      <div>
        {{ $t('报警状态') }}：
        <span :class="alarmStatus | alarmClass">{{ alarmStateText }}</span>
      </div>
      <div>
        {{ $t('运行状态') }}：
        <span :class="runState | runClass">{{ runStateText }}</span>
      </div>
    </div>
    <div class="common-border">
      <el-row type="flex" justify="center" align="middle" class="pump-status common-border2">
        <el-col tag="span" :span="8" :lg="6">
          <span class="iconfont icon-pump"></span>
          {{ $t('泵安装状态') }}：{{ pumpStatus.install | pumpInstallText | translateTo }}
        </el-col>
        <el-col tag="span" :span="8" :lg="6">
          <span class="iconfont icon-pump"></span>
          {{ $t('泵运行状态') }}：{{ pumpStatus.run | pumpRunText | translateTo }}
        </el-col>
        <el-col tag="span" :span="8" :lg="6" v-if="!isEmpty(absoluteHumidity)">
          <span class="iconfont icon-humidity2"></span>
          {{ $t('绝对湿度') }}：{{ absoluteHumidity }}g/m³
        </el-col>
        <el-col tag="span" :span="8" :lg="6">
          <span class="iconfont icon-humidity2"></span>
          {{ $t('相对湿度') }}：{{ humidity }}%
        </el-col>
        <el-col tag="span" :span="8" :lg="6" v-if="!isEmpty(atmosphericPressure)">
          <span class="iconfont icon-dqyq"></span>
          {{ $t('大气压强') }}：{{ atmosphericPressure }}kPa
        </el-col>
        <el-col tag="span" :span="8" :lg="6">
          <span class="iconfont icon-temperature2"></span>
          {{ $t('温度') }}：{{ temperature }}℃
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { tools } from '../utils';
import { isEmpty } from '@/utils/is';

export default {
  props: {
    networkMode: {
      type: Number,
      default: 0
    },
    alarmStatus: {
      type: Number,
      default: 0
    },
    runState: {
      type: Number,
      default: 0
    },
    pumpStatus: {
      type: Object,
      default: () => ({
        install: 0,
        run: 0
      })
    },
    humidity: {
      type: Number,
      required: true
    },
    temperature: {
      type: Number,
      requires: true
    },
    absoluteHumidity: {
      type: Number,
      requires: true
    },
    atmosphericPressure: {
      type: Number,
      requires: true
    }
  },
  computed: {
    alarmStateText() {
      return this.$t(tools.alarmText(this.alarmStatus));
    },
    runStateText() {
      return this.$t(tools.runText(this.runState));
    }
  },
  filters: tools,
  methods: {
    isEmpty
  }
};
</script>

<style lang="scss">
.gd606-status-bar {
  .common-border {
    margin-top: var(--device-status-mt);
  }

  .col-btn {
    color: #49c7c3;

    cursor: pointer;

    &:hover {
      color: #3da4a2;
      border-color: transparent;
      background-color: transparent;
    }
  }

  .gd606-status-top {
    display: flex;
    justify-content: flex-end;
    gap: 20px;

    font-size: var(--font-size);
    text-align: left;
    gap: 20px;
  }

  .iconfont {
    font-size: 20px;
    color: $normal-color;
  }

  .pump-status {
    height: 50px;
  }
  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: var(--font-size);
    padding-left: 20px;
    text-align: left;
  }
}
</style>
